/** Default scene backdrop — lighter centre, darker edges (matches classic DataViewer look). */
export const DEFAULT_SCENE_BG_CSS =
  'radial-gradient(circle at 50% 45%, #5a5a5a 0%, #404040 38%, #212121 72%, #141414 100%)';

function parseHex(hex) {
  if (!hex || typeof hex !== 'string') return null;
  let h = hex.trim().replace('#', '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
    num: parseInt(h, 16),
  };
}

function toHex({ r, g, b }) {
  const clamp = (n) => Math.max(0, Math.min(255, Math.round(n)));
  return `#${[clamp(r), clamp(g), clamp(b)]
    .map((n) => n.toString(16).padStart(2, '0'))
    .join('')}`;
}

function mix(rgb, target, t) {
  return {
    r: rgb.r + (target.r - rgb.r) * t,
    g: rgb.g + (target.g - rgb.g) * t,
    b: rgb.b + (target.b - rgb.b) * t,
  };
}

/**
 * CSS for the scene stage. null → classic radial; hex → radial vignette around that colour.
 * Three.js clear stays transparent so this CSS shows through.
 */
export function sceneBackgroundCss(sceneBgColor) {
  if (!sceneBgColor) return DEFAULT_SCENE_BG_CSS;
  const rgb = parseHex(sceneBgColor);
  if (!rgb) return DEFAULT_SCENE_BG_CSS;
  const center = toHex(mix(rgb, { r: 255, g: 255, b: 255 }, 0.28));
  const mid = toHex(rgb);
  const edge = toHex(mix(rgb, { r: 0, g: 0, b: 0 }, 0.55));
  const rim = toHex(mix(rgb, { r: 0, g: 0, b: 0 }, 0.78));
  return `radial-gradient(circle at 50% 45%, ${center} 0%, ${mid} 38%, ${edge} 72%, ${rim} 100%)`;
}

export function sceneBackgroundSwatch(sceneBgColor) {
  return sceneBackgroundCss(sceneBgColor);
}
